/* Copyright 2013 - 2022 Waiterio LLC */
export default 'c155da6c227112fdcb9a10a2'
